<template>
  <article class="subexercise">
    <h1>{{index + 1}}</h1>
    <h4>Sværhedsgrad</h4>
    <difficulties :difficulties="exercise.difficulties"></difficulties>
    <h4 v-if="exercise.description">Beskrivelse</h4>
    <p>{{{exercise.description}}}</p>
    
    <h4 v-if="exercise.execution">Trin</h4>
    <p>{{{exercise.execution}}}</p>

    <h4 v-if="exercise.input">Input</h4>
    <p>{{{exercise.input}}}</p>

    <h4 v-if="exercise.remarks">Bemærkninger</h4>
    <p>{{{exercise.remarks}}}</p>
  </article>
</template>

<script>
import Difficulties from 'components/Difficulties'
export default {
  components: {
    Difficulties
  },
  props: {
    exercise: Object,
    index: Number
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// SubExercise.vue?2fe1db41